import React from 'react';
import Header from '../components/Header';
import CSVMigrator from '../components/CSVMigrator';

const CSVMigratorPage = () => {
  return (
    <div>
      <Header />
      <div style={{ marginTop: '120px', padding: '20px' }}>
        <CSVMigrator />
      </div>
    </div>
  );
};

export default CSVMigratorPage;